import { useContext } from 'react';

import { DeviceIdContext, type DeviceIdContextType } from '../client/DeviceIdProvider';

export function useDeviceId(): DeviceIdContextType {
	const context = useContext(DeviceIdContext);

	if (!context) {
		throw new Error('"useDeviceId" must be used within a Provider');
	}

	return context;
}
